import { __assign, __rest } from "tslib";
import React from "react";
import cn from "classnames";
export var TextInput = React.memo(function (props) {
    var className = props.className, restProps = __rest(props, ["className"]);
    return (React.createElement("input", __assign({}, restProps, { className: cn("focus:ring-indigo-500", "focus:border-indigo-500", "disabled:text-gray-500", "disabled:bg-gray-100", "shadow-sm", "text-sm", "leading-6", "font-normal", "text-gray-900", "border-gray-300", "placeholder-gray-500", "rounded-md", props.className) })));
});
